/** Read current plain-text errors and legacy serialized Meta errors. */
export const creativeErrorMessage = (error) => {
    let value = error
    if (typeof value === 'string') {
        try { value = JSON.parse(value) } catch { return value.trim() }
    }
    if (typeof value === 'string') return value.trim()
    const message = value?.response?.error_user_msg || value?.response?.error?.error_user_msg ||
        value?.error_user_msg || value?.message
    return typeof message === 'string' ? message.trim() : ''
}
